/**
 * НАЗНАЧЕНИЕ: Выгрузка отчета Excel по слайдам, выбранным чекбоксами
 * ОПИСАНИЕ: Пункт левого меню «Отчет». Работает с тем же списком
 * выделенных слайдов (store.slides.selected), что «Экспорт» и «Удаление»
 * ФОРМАТ: .xlsx формируется на сервере (POST /api/slides/report/),
 * колонки повторяют таблицу на главной странице
 */
import React, {useState} from "react";
import {useSelector} from "react-redux";
import Button from "@mui/material/Button";

import {downloadSlidesReport} from "../../../shared/api/slides";

const buildFileName = () => {
    const now = new Date();
    const pad = (value) => String(value).padStart(2, "0");

    const date = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
    const time = `${pad(now.getHours())}-${pad(now.getMinutes())}`;

    return `Отчет_по_слайдам_${date}_${time}.xlsx`;
};

export const Report = () => {

    const selected = useSelector((store) => store.slides.selected);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");

    const downloadReportHandler = async () => {
        setIsLoading(true);
        setError("");

        try {
            const slideIds = selected.map((slide) => slide.id);
            const blob = await downloadSlidesReport(slideIds);

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = buildFileName();
            link.click();
            window.URL.revokeObjectURL(url);
        } catch (requestError) {
            console.error("Ошибка формирования отчета:", requestError);
            setError("Не удалось сформировать отчет. Повторите попытку позднее");
        } finally {
            setIsLoading(false);
        }
    };

    if (selected.length === 0) {
        return (
            <div onClick={(e) => e.stopPropagation()}>
                <p>Список для отчета - пуст</p>
            </div>
        );
    }

    return (
        // Пункт меню сворачивается по клику, поэтому клики внутри панели
        // не пропускаем наверх
        <div onClick={(e) => e.stopPropagation()}>
            <ul className="menu-selected-list">
                {selected.map((item, index) => (
                    <li key={item.id + index}>{item.name}</li>
                ))}
            </ul>
            <Button
                color="primary"
                variant="contained"
                size="medium"
                style={{marginTop: '10px'}}
                disabled={isLoading}
                onClick={downloadReportHandler}
            >
                {isLoading ? "Формирование..." : "Скачать отчет"}
            </Button>
            {error && <p style={{color: "#d32f2f"}}>{error}</p>}
        </div>
    );
};
